<script>
  import ConductInspectionModalIssueDetail
    from '@/_legacy/components/ConductInspection/ConductInspectionModal/ConductInspectionModalIssueDetail.vue';
  import { d } from '@/ui/i18n/i18n';

  export default {
    name: 'ConductInspectionItemAction',
    components: {
      ConductInspectionModalIssueDetail,
    },
    props: {
      entities: {
        type: Object,
        required: true,
      },
      item: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      isDetailsModalOpen: false,
    }),
    computed: {
      itemExecutedAt() {
        return d(this.item.executed_at, 'shortDateTime');
      },
      isVisibleForConductor() {
        if (this.item.visible_for_conductor) {
          return true;
        }

        if (this.item.settings) {
          return Object.keys(this.item.settings).map(key => this.item.settings[key]).some(v => v === true);
        }

        return false;
      },
    },
  };
</script>

<template>
  <div v-if="isVisibleForConductor" class="preview__question">
    <h2 v-if="item.executed_at">
      {{ $t('The issue was raised at "{date}".', { date: itemExecutedAt }) }}
    </h2>
    <h2 v-else>
      {{
        $t(
          'Hint: When you submit your check results, issue "{issue}" is raised automatically.',
          { issue: item.params.title },
        )
      }}
    </h2>

    <button
      class="btn btn-default btn-primary relative"
      @click="isDetailsModalOpen = true"
    >
      {{ $t('See details') }}
    </button>

    <portal to="modals">
      <transition name="fade">
        <ConductInspectionModalIssueDetail
          v-if="isDetailsModalOpen"
          :item="item"
          :users="entities.inspection.users"
          @close="isDetailsModalOpen = false"
        />
      </transition>
    </portal>
  </div>
</template>
